// Centralized route table. Pages register here; App.jsx renders them.
// Keep this file dumb data so it can be introspected for breadcrumbs,
// sitemaps, etc.

import Home              from '../pages/Home';
import HomeMobile        from '../pages/HomeMobile';
import Tutors            from '../pages/Tutors';
import CoursesIndex      from '../pages/CoursesIndex';
import CourseDetail      from '../pages/CourseDetail';
import CaseStudyDetail   from '../pages/CaseStudyDetail';
import Certificate       from '../pages/Certificate';
import ProviderOnboarding from '../pages/ProviderOnboarding';
import About             from '../pages/About';
import BlogIndex         from '../pages/BlogIndex';
import BlogPost          from '../pages/BlogPost';

export const ROUTES = [
  { path: '/',                       element: Home,               label: 'Home',          public: true },
  { path: '/m',                      element: HomeMobile,         label: 'Mobile preview', public: true },

  { path: '/courses',                element: CoursesIndex,       label: 'Courses',       public: true },
  { path: '/courses/:slug',          element: CourseDetail,       label: 'Course detail', public: true },

  { path: '/tutors',                 element: Tutors,             label: 'Tutors',        public: true },

  { path: '/case-studies/:slug',     element: CaseStudyDetail,    label: 'Case study',    public: true },
  { path: '/certificates/:slug',     element: Certificate,        label: 'Certificate',   public: true },

  { path: '/providers',              element: ProviderOnboarding, label: 'For providers', public: true },
  { path: '/about',                  element: About,              label: 'About',         public: true },

  { path: '/blog',                   element: BlogIndex,          label: 'Blog',          public: true },
  { path: '/blog/:slug',             element: BlogPost,           label: 'Blog post',     public: true },
];
